import { useNavigate } from 'react-router-dom';
import AppIcon from './AppIcon';
import { cn } from '../utils/cn';

/**
 * يحسب مسار الرجوع من pathname الحالي بشكل هرمي.
 * مثال: /photographer-dashboard/profile/form → /photographer-dashboard/profile
 * مثال: /customer-dashboard → /
 */
export const getBackPath = (pathname) => {
  const segments = pathname.replace(/\/$/, '').split('/').filter(Boolean);
  if (segments.length <= 1) return '/';
  segments.pop();
  return '/' + segments.join('/');
};

/**
 * زر رجوع موحد لتحسين تجربة المستخدم.
 * @param {string|number} to - مسار الرجوع (مثل '/dashboard') أو -1 للرجوع في السجل
 * @param {string} [label='رجوع'] - النص بجانب السهم
 * @param {string} [className] - كلاسات إضافية
 * @param {React.ReactNode} [children] - إن وُجد يستبدل النص الافتراضي
 */
const BackButton = ({ to = -1, label = 'رجوع', className, children }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to);
  };

  const showLabel = (children ?? label) !== '' && (children ?? label) != null;

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        'inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary/20 focus:ring-offset-2 rounded-lg py-2 px-1 -mr-1',
        className
      )}
    >
      <AppIcon name="ArrowRight" size={20} className="flex-shrink-0" />
      {showLabel && <span>{children ?? label}</span>}
    </button>
  );
};

export default BackButton;
